import { Route } from '@/app/router'

// EBAY
const Integration = () => import('./ebay/index.vue')
const IntegrationList = () => import('./ebay/components/AdContent/children/AdsList/index.vue')
const IntegrationOrders = () =>
	import('./ebay/components/AdContent/children/AdOrders/index.vue')
const IntegrationSettings = () =>
	import('./ebay/components/AdContent/children/AdSettings/index.vue')

// CUSTOM INTEGRATIONS
const CustomIntegrations = () => import('./custom/index.vue')

export default [

	new Route('/integrations/custom-integrations', CustomIntegrations).as(
		'Dashboard:Integration:Custom'
	).permissions(['VIEW_EXTERNAL_INTEGRATION_SETTINGS', 'VIEW_EXTERNAL_INTEGRATION']),

	new Route('/integrations/ebay/:id', Integration)
		.children([
			new Route('integration-list', IntegrationList).as(
				'Dashboard:Integration:Ebay:List'
			),
			new Route('integration-orders', IntegrationOrders).as(
				'Dashboard:Integration:Ebay:Orders'
			),
			new Route('/', IntegrationSettings).as('Dashboard:Integration:Ebay')
		])
		.permissions(['VIEW_EXTERNAL_INTEGRATION_SETTINGS', 'VIEW_EXTERNAL_INTEGRATION'])
]
